<template>
  <!-- filter kategorija recepata; izgled isti kao filter dogadjaja i oglasa (assets/scss/adsFilter.scss) -->
  <div class="afl-cats">
    <div class="my-filter-container-desktop afl">
      <!-- uzi ekran: naslov koji otvara/zatvara filter -->
      <div class="btn-expanded" @click="toggle">
        <div class="filter-text text-uppercase text-muted">Filteri</div>
        <div class="filter-img-awesome text-right">
          <i class="esei text-muted d-block" :class="isOpen ? 'icon-chevron-up' : 'icon-chevron-down'"></i>
        </div>
      </div>

      <div class="drop-container p-2" :class="{ 'show-container': isOpen }">
        <section class="afl-sec afl-sec-first">
          <h5 class="afl-sec-title">Kategorije</h5>

          <div class="afl-search">
            <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
            <input v-model="categoryQuery"
                   type="search"
                   class="afl-input"
                   placeholder="Pronađi kategoriju…"
                   aria-label="Pronađi kategoriju"
                   autocomplete="off" />
          </div>

          <!-- pravi linkovi (vide ih i pretrazivaci) -->
          <ul class="afl-list">
            <li>
              <NuxtLink class="afl-item"
                        :class="{ on: !route.params.category }"
                        :to="routePath({ name: 'recepti-page', params: { page: 1 } })"
                        @click="closeOnMobile">
                <span>Sve kategorije</span>
              </NuxtLink>
            </li>

            <li v-for="category in visibleCategories" :key="category.id">
              <NuxtLink class="afl-item"
                        :class="{ on: isSelected(category) }"
                        :to="routePath({ name: 'recepti-category-page', params: { category: slug(category), page: 1 } })"
                        @click="closeOnMobile">
                <span>{{ category.name }}</span>
              </NuxtLink>
            </li>

            <li v-if="!visibleCategories.length" class="afl-empty">{{ categoryQuery ? `Nema kategorije za „${categoryQuery}“.` : 'Nema kategorija.' }}</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { normalizeText } from '~/composables/useListFilter'

const props = defineProps({
  categories: { type: Array, default: () => [] },
})

const route = useRoute()
const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()

const slug = (category) => $srbTolat.srbTolatPathSlugify(category.name)
const isSelected = (category) => String(route.params.category || '') === slug(category)

// pretraga kategorija u listi (lokalno, bez kvacica)
const categoryQuery = ref('')

const visibleCategories = computed(() => {
  const list = props.categories ?? []
  const query = normalizeText(categoryQuery.value)

  return query ? list.filter((category) => normalizeText(category.name).includes(query)) : list
})

// uzi ekran: filter je zatvoren dok se ne klikne "Filteri"; na sirem ekranu (>= 990) uvek zatvoren
const isOpen = ref(false)
const toggle = () => { isOpen.value = !isOpen.value }

const handleResize = () => {
  if (window.innerWidth >= 990) isOpen.value = false
}

const closeOnMobile = () => {
  if (window.innerWidth < 990) isOpen.value = false
}

onMounted(() => window.addEventListener('resize', handleResize))
onBeforeUnmount(() => window.removeEventListener('resize', handleResize))
</script>
